import mod from "-!./register.js?vue&type=script&lang=js&"; export default mod; export * from "-!./register.js?vue&type=script&lang=js&"